/**
 * loadWindowData
 * @param {string} namespace - Usually 'PageData' which is populate in razor view
 * @param {string} childKey - property key in PageData
 * @param {boolean} noDefault - default false to fall back to empty object when target is undefined.
 * @returns value | empty object | undefined
 */
function loadWindowData() {
  var namespace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var childKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var noDefault = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var ret;
  // @ts-ignore
  if (window[namespace] && childKey) {
    // @ts-ignore
    ret = window[namespace][childKey];
    return noDefault ? ret : ret || {};
  }
  // @ts-ignore
  ret = window[namespace];
  return noDefault ? ret : ret || {};
}
/**
 * transformContent
 * @param {string} content
 * @param {string | array} params
 * @description
 * helper function that insert dynamic data into static content and return as one string
 * example
 * content: "test to bind {0} with dynamic {1} value"
 * params: ['sentence A', 'B']
 * returns
 * string: "test to bind sentence A with dynamic B value"
 */
var transformContent = (content, params) => {
  var ret = content;
  if (ret.length > 1 && params !== null) {
    if (Array.isArray(params)) {
      [...params].forEach((item, index) => {
        var replace = "\\{".concat(index, "\\}");
        var re = new RegExp(replace, 'g');
        ret = ret.replace(re, item);
      });
    } else {
      ret = ret.replace(/\{0\}/g, params);
    }
  }
  return ret;
};

/**
 * getContent
 * @param {string} content
 * @param {string | array | null} params
 * @description
 * checks if params are passed to call transformContent or return as is
 */
var getContent = (content, params) => {
  var ret = content;
  if (content && params !== null) {
    ret = transformContent(content, params);
  }
  return ret;
};

/**
 * getContent
 * @param {string} content
 * @param {string | array} params
 * @param {string | array } specialKey
 * @param {string | undefined} NAMESPACE
 * @param {string | undefined} AEM_CONTENT
 * @description
 * checks for the project name space and aem key to see if the content exists
 * then transforms the content 
 */

var getContentByKey = (contentKey, params, specialKey, NAMESPACE, AEM_CONTENT) => {
  // update resource variable
  var resource = loadWindowData(NAMESPACE, AEM_CONTENT);
  if (!contentKey || !resource) {
    return '';
  }
  var keys = contentKey.split('.');
  var content = resource;
  for (var i = 0, len = keys.length; i < len; i++) {
    content = content[keys[i]];
    if (!content) {
      return '';
    }
  }
  if (content && specialKey) {
    content = content[specialKey] || '';
  }
  if (content && params !== null) {
    content = transformContent(content, params);
    if (Array.isArray(params)) {
      [...params].forEach((item, index) => {
        var regex = new RegExp("\\{".concat(index, "\\}"), 'g');
        content = content.replace(regex, item);
      });
    } else {
      content = content.replace(/\{0\}/g, params);
    }
  }
  return content;
};
var isNullOrWhiteSpace = str => !str || !str.trim();
var isEmpty = obj => obj && Object.keys(obj).length === 0 && obj.constructor === Object;
var isTrue = function isTrue() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return !!str && (str.toLowerCase() === 'true' || str.toLowerCase() === 'yes');
};
var wrapHtml = content => ({
  __html: content
});
var arrayToSentence = arr => {
  var arrTemp = [...arr];
  var arrTempLength = arrTemp.length;
  if (arrTempLength <= 1) {
    return arrTemp.toString();
  }
  var tail = arrTemp.pop();
  return "".concat(arrTemp.join(', '), " and ").concat(tail);
};
var arrayToCommaSeparated = arr => {
  var arrTemp = [...arr];
  return arrTemp.join(', ');
};

/**
 * isHtmlString
 * @param {String} htmlString
 * @returns {Boolean}
 * @description test is given html string contains html element
 */
var isHtmlString = function isHtmlString() {
  var htmlString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!htmlString) {
    return false;
  }
  var frag = document.createRange().createContextualFragment("".concat(htmlString));
  return frag.firstElementChild !== null;
};
var getTextContent = function getTextContent() {
  var htmlString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var ret = '';
  if (htmlString) {
    var domNode = document.createElement('div');
    domNode.innerHTML = htmlString;
    ret = domNode.textContent || '';
  }
  return ret;
};
var toTitleCase = function toTitleCase() {
  var stg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!stg) {
    return '';
  }
  return stg.trim().split(' ').map(text => text.trim().split('-').map(t => "".concat(t[0].toUpperCase()).concat(t.substr(1).toLowerCase())).join('-')).join(' ');
};
var mapKeyValueListToObjectList = keyValueList => {
  var options = [];
  if (keyValueList && keyValueList.length > 0) {
    keyValueList.forEach(keyValue => {
      var option = {};
      // @ts-ignore
      keyValue.forEach(item => {
        // @ts-ignore
        option[item.key] = item.value;
      });
      options.push(option);
    });
  }
  return options;
};
var getKeyByValue = (object, value) => Object.keys(object).find(key => object[key] === value);
var getKeysByValue = (object, value) => Object.keys(object).filter(key => object[key] === value);
var preselectCards = function preselectCards() {
  var selected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (typeof selected === 'string' || selected instanceof String) {
    return {
      [selected.toString()]: true
    };
  }
  if (Array.isArray(selected)) {
    return selected.reduce((ret, cur, i) => {
      ret[cur] = true;
      return ret;
    }, {});
  }
  return {};
};
var compare = (a, b) => {
  if (a.sortOrder < b.sortOrder) {
    return -1;
  }
  if (a.sortOrder > b.sortOrder) {
    return 1;
  }
  return 0;
};

export { arrayToCommaSeparated, arrayToSentence, compare, getContent, getContentByKey, getKeyByValue, getKeysByValue, getTextContent, isEmpty, isHtmlString, isNullOrWhiteSpace, isTrue, loadWindowData, mapKeyValueListToObjectList, preselectCards, toTitleCase, transformContent, wrapHtml };
